export default __webpack_public_path__ + "static/media/1320.eaa695b7.png";